module.exports = __webpack_public_path__ + "static/media/grocery-slide-2.aca5036c.png";